<div class="auction-cntr">

    <div class="fb-title">

        <h2> {{ configuration.title }} </h2>

    </div>

    <p-tabView>

        <p-tabPanel [header]="tab.tabConfiguration?.title ?? 'Aste'" *ngFor="let tab of configuration.auctions">

            <ng-container *ngIf="tab.auctions.length > 0; else noAuctionTemplate">

                <ng-container *ngFor="let card of tab.auctions">

                    <div class="card-auction">

                        <fb-auction-card [configuration]="card"></fb-auction-card>

                    </div>

                </ng-container>
            </ng-container>

            <ng-template #noAuctionTemplate>
                <div class="no-auction-cntr">
                    <h3>Nessun asta disponibile.</h3>
                </div>
            </ng-template>

        </p-tabPanel>

    </p-tabView>

</div>
